import { Button, Link, Spinner, Stack, Text } from '@chakra-ui/react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { memo } from 'react';
import ProofLocation from '../proofLocation';
import { IProofLocationProps } from '../../../services/hooks/ProofLocation/useGetProofLocation';
import { useGetClientData } from '../../../services/hooks/ClientData/useGetClientData';
import { IoMdDownload } from 'react-icons/io';
import { BsEyeFill } from 'react-icons/bs';

interface IOwnProps {
  data?: IProofLocationProps;
  isModeViewer?: boolean;
}

const ProofLocationButton: React.FC<IOwnProps> = ({ data, isModeViewer }) => {
  const ClientData = useGetClientData();
  return (
    <Stack>
      <PDFDownloadLink
        document={
          <ProofLocation
            data={data}
            instituteLogo={ClientData?.data?.institute_logo}
            portrait_logo={ClientData?.data?.portrait_logo}
          />
        }
        fileName="local_de_prova.pdf"
      >
        {({ loading, blob }) => {
          if (!blob) return;
          return (
            <Button
              bg="primaryColor"
              color="white"
              _hover={{ backgroundColor: 'none' }}
              w={['100%', '100%', '100%', 'fit-content']}
              whiteSpace="break-spaces"
              leftIcon={isModeViewer ? <BsEyeFill /> : <IoMdDownload />}
            >
              {(isModeViewer && (
                <Link href={URL.createObjectURL(blob)} target="_blank">
                  {(loading && <Spinner />) || <Text>Visualizar Comprovante</Text>}
                </Link>
              )) ||
                (loading && <Spinner />) || <Text size="md">Baixar Comprovante</Text>}
            </Button>
          );
        }}
      </PDFDownloadLink>
    </Stack>
  );
};

export default memo(ProofLocationButton);
